var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"banner text-center\"\u003E\u003Cdiv class=\"sub-title text-center\"\u003EAbout our company\u003C\u002Fdiv\u003E\u003Ch1\u003EThe new way to solve Identity\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/partials/banner.pug
// module id = 1067
// module chunks = 0